"use strict";
exports.__esModule = true;
exports.GeoChartInner = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var throttle_1 = tslib_1.__importDefault(require("lodash/throttle"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var react_measure_1 = tslib_1.__importDefault(require("react-measure"));
var uuid_1 = require("uuid");
var GeoChartRenderer_1 = tslib_1.__importDefault(require("./GeoChartRenderer"));
var GeoChartLegendRenderer_1 = tslib_1.__importDefault(require("./GeoChartLegendRenderer"));
var data_1 = require("./helpers/geoChart/data");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var common_1 = require("./helpers/geoChart/common");
var responsive_1 = require("./helpers/geoChart/responsive");
function renderChart(props) {
    return react_1["default"].createElement(GeoChartRenderer_1["default"], tslib_1.__assign({}, props));
}
function renderLegend(props) {
    return (react_1["default"].createElement(sdk_ui_1.IntlWrapper, { locale: props.locale },
        react_1["default"].createElement(sdk_ui_1.IntlTranslationsProvider, null, function (translationProps) { return (react_1["default"].createElement(GeoChartLegendRenderer_1["default"], tslib_1.__assign({}, props, { numericSymbols: translationProps.numericSymbols }))); })));
}
var DefaultGeoConfig = {
    mapboxToken: ""
};
/**
 * Geo Chart react component
 */
var GeoChartInner = /** @class */ (function (_super) {
    tslib_1.__extends(GeoChartInner, _super);
    function GeoChartInner(props) {
        var _this = _super.call(this, props) || this;
        _this.containerId = "geo-" + uuid_1.v4();
        _this.onLegendItemClick = function (item) {
            var enabledLegendItems = _this.state.enabledLegendItems.map(function (legendItem, index) {
                if (index === item.legendIndex) {
                    return !legendItem;
                }
                return legendItem;
            });
            _this.setState({ enabledLegendItems: enabledLegendItems });
        };
        _this.renderChart = function (geoChartOptions) {
            var _a = _this.props.chartRenderer, chartRenderer = _a === void 0 ? renderChart : _a;
            var chartProps = _this.getChartProps(geoChartOptions);
            return chartRenderer(chartProps);
        };
        _this.renderLegend = function (height, position, geoChartOptions, contentRect) {
            var _a, _b, _c;
            var enabled = (_c = (_b = (_a = _this.props.config) === null || _a === void 0 ? void 0 : _a.legend) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : true;
            var _d = _this.props.legendRenderer, legendRenderer = _d === void 0 ? renderLegend : _d;
            if (!enabled) {
                return null;
            }
            var legendProps = _this.getLegendProps(height, position, geoChartOptions, contentRect);
            return legendRenderer(legendProps);
        };
        _this.onWindowResize = function () {
            var _a = _this.props.documentObj, documentObj = _a === void 0 ? document : _a;
            _this.setState({
                showFluidLegend: sdk_ui_vis_commons_1.shouldShowFluid(documentObj)
            });
        };
        var _a = _this.props.documentObj, documentObj = _a === void 0 ? document : _a;
        _this.state = {
            enabledLegendItems: [],
            showFluidLegend: sdk_ui_vis_commons_1.shouldShowFluid(documentObj),
            colorAssignmentItem: []
        };
        _this.throttledOnWindowResize = throttle_1["default"](_this.onWindowResize, 100);
        return _this;
    }
    GeoChartInner.getDerivedStateFromProps = function (nextProps, prevState) {
        var geoChartOptions = nextProps.geoChartOptions;
        if (!geoChartOptions) {
            return null;
        }
        var categoryItems = geoChartOptions.categoryItems, colorStrategy = geoChartOptions.colorStrategy;
        var colorAssignmentItem = colorStrategy.getColorAssignment();
        if (!common_1.isColorAssignmentItemChanged(prevState.colorAssignmentItem, colorAssignmentItem)) {
            return null;
        }
        return {
            enabledLegendItems: new Array(categoryItems.length).fill(true),
            colorAssignmentItem: colorAssignmentItem
        };
    };
    GeoChartInner.prototype.componentDidMount = function () {
        this.updateConfigurationPanel(this.props.geoChartOptions);
        window.addEventListener("resize", this.throttledOnWindowResize);
    };
    GeoChartInner.prototype.componentDidUpdate = function () {
        this.updateConfigurationPanel(this.props.geoChartOptions);
    };
    GeoChartInner.prototype.componentWillUnmount = function () {
        this.throttledOnWindowResize.cancel();
        window.removeEventListener("resize", this.throttledOnWindowResize);
    };
    GeoChartInner.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, height = _b.height, config = _b.config;
        if (height !== undefined && !responsive_1.isAutoPositionWithPopup((_a = config === null || config === void 0 ? void 0 : config.legend) === null || _a === void 0 ? void 0 : _a.responsive)) {
            return this.renderVisualizationContent(undefined, height);
        }
        return (react_1["default"].createElement(react_measure_1["default"], { client: true }, function (_a) {
            var _b;
            var measureRef = _a.measureRef, contentRect = _a.contentRect;
            var contentRectClient = contentRect.client;
            return _this.renderVisualizationContent(measureRef, (_b = (contentRectClient && contentRectClient.height)) !== null && _b !== void 0 ? _b : 0, contentRect);
        }));
    };
    GeoChartInner.prototype.renderVisualizationContent = function (measureRef, height, contentRect) {
        var geoChartOptionsProp = this.props.geoChartOptions;
        var geoChartOptions = this.syncWithLegendItemStates(geoChartOptionsProp);
        var legendDetails = this.getLegendDetails(this.getLegendPosition(), contentRect);
        var position = legendDetails ? legendDetails.position : sdk_ui_vis_commons_1.LegendPosition.TOP;
        var classes = this.getContainerClassName(position);
        var isLegendRenderedFirst = position === sdk_ui_vis_commons_1.LegendPosition.TOP ||
            (position === sdk_ui_vis_commons_1.LegendPosition.LEFT && !this.state.showFluidLegend);
        var legendComponent = this.renderLegend(height, position, geoChartOptions, contentRect);
        return (react_1["default"].createElement("div", { className: classes, ref: measureRef },
            isLegendRenderedFirst && legendComponent,
            this.renderChart(geoChartOptions),
            !isLegendRenderedFirst && legendComponent));
    };
    GeoChartInner.prototype.syncWithLegendItemStates = function (geoChartOptions) {
        ts_invariant_1["default"](geoChartOptions, "illegal state - trying to sync legend with no geo options");
        var categoryItems = geoChartOptions.categoryItems;
        var enabledLegendItems = this.state.enabledLegendItems;
        var withLegendItemStates = categoryItems.map(function (item, index) { return (tslib_1.__assign(tslib_1.__assign({}, item), { isVisible: enabledLegendItems[index] })); });
        return tslib_1.__assign(tslib_1.__assign({}, geoChartOptions), { categoryItems: withLegendItemStates });
    };
    GeoChartInner.prototype.getContainerClassName = function (position) {
        var _a;
        var _b, _c, _d;
        var responsive = responsive_1.getResponsiveInfo((_d = (_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.legend) === null || _d === void 0 ? void 0 : _d.responsive) === true;
        var flexDirection = this.getFlexDirection(position);
        return classnames_1["default"]("viz-line-family-chart-wrap", "gd-geo-component", "s-gd-geo-component", (_a = {
                "responsive-legend": responsive,
                "non-responsive-legend": !responsive
            },
            _a["flex-direction-" + flexDirection] = true,
            _a["legend-position-bottom"] = position === sdk_ui_vis_commons_1.LegendPosition.BOTTOM,
            _a), this.containerId);
    };
    GeoChartInner.prototype.getFlexDirection = function (position) {
        var isFluidLegend = this.isFluidLegend();
        if (position === sdk_ui_vis_commons_1.LegendPosition.TOP || position === sdk_ui_vis_commons_1.LegendPosition.BOTTOM || isFluidLegend) {
            return "column";
        }
        return "row";
    };
    GeoChartInner.prototype.isFluidLegend = function () {
        var _a, _b, _c;
        var showFluidLegend = this.state.showFluidLegend;
        var responsive = responsive_1.getResponsiveInfo((_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.legend) === null || _c === void 0 ? void 0 : _c.responsive);
        return responsive_1.isAutoPositionWithPopup(responsive)
            ? false
            : common_1.isFluidLegendEnabled(responsive, showFluidLegend);
    };
    GeoChartInner.prototype.getLegendPosition = function () {
        var _a, _b, _c;
        var position = (_c = (_b = (_a = this.props.config) === null || _a === void 0 ? void 0 : _a.legend) === null || _b === void 0 ? void 0 : _b.position) !== null && _c !== void 0 ? _c : sdk_ui_vis_commons_1.LegendPosition.TOP;
        var isSupportedLegend = sdk_ui_vis_commons_1.SupportedLegendPositions.indexOf(position) > -1;
        return isSupportedLegend ? position : sdk_ui_vis_commons_1.LegendPosition.TOP;
    };
    GeoChartInner.prototype.getLegendDetails = function (position, contentRect) {
        var _a, _b;
        var _c = this.props, geoChartOptionsProp = _c.geoChartOptions, config = _c.config;
        var geoChartOptions = this.syncWithLegendItemStates(geoChartOptionsProp);
        var geoData = geoChartOptions.geoData;
        var legendLabel = (_a = geoData === null || geoData === void 0 ? void 0 : geoData.segment) === null || _a === void 0 ? void 0 : _a.name;
        var isFluidLegend = this.isFluidLegend();
        var legendDetailOptions = {
            showFluidLegend: isFluidLegend,
            contentRect: contentRect,
            legendLabel: legendLabel
        };
        return sdk_ui_vis_commons_1.getLegendDetails(position, responsive_1.getResponsiveInfo((_b = config === null || config === void 0 ? void 0 : config.legend) === null || _b === void 0 ? void 0 : _b.responsive), legendDetailOptions);
    };
    GeoChartInner.prototype.getLegendProps = function (height, position, geoChartOptions, contentRect) {
        var _a, _b, _c, _d;
        var responsive = (_b = (_a = this.props.config) === null || _a === void 0 ? void 0 : _a.legend) === null || _b === void 0 ? void 0 : _b.responsive;
        var locale = this.props.locale;
        var enabledLegendItems = this.state.enabledLegendItems;
        var isFluidLegend = this.isFluidLegend();
        var geoData = geoChartOptions.geoData, colorStrategy = geoChartOptions.colorStrategy, categoryItems = geoChartOptions.categoryItems;
        var segment = geoData.segment;
        var colorFormat = (_c = geoData.color) === null || _c === void 0 ? void 0 : _c.format;
        var sizeFormat = (_d = geoData.size) === null || _d === void 0 ? void 0 : _d.format;
        var propsFromData = {
            format: colorFormat || sizeFormat,
            geoData: geoData
        };
        var colorLegendValue = colorStrategy.getColorByIndex(0);
        var legendDetails = this.getLegendDetails(position, contentRect);
        var legendProps = {
            height: height,
            locale: locale,
            position: position,
            responsive: responsive,
            isFluidLegend: isFluidLegend,
            onItemClick: this.onLegendItemClick,
            contentRect: contentRect,
            containerId: this.containerId
        };
        if (legendDetails) {
            legendProps = tslib_1.__assign(tslib_1.__assign({}, legendProps), { maxRows: legendDetails.maxRows, name: legendDetails.name, renderPopUp: legendDetails.renderPopUp });
        }
        if (segment && enabledLegendItems.length) {
            return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, legendProps), propsFromData), { categoryItems: categoryItems,
                colorLegendValue: colorLegendValue });
        }
        return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, legendProps), propsFromData), { colorLegendValue: colorLegendValue });
    };
    GeoChartInner.prototype.getChartProps = function (geoChartOptions) {
        var _a;
        var _b = this.props, _c = _b.config, config = _c === void 0 ? DefaultGeoConfig : _c, dataView = _b.dataView, _d = _b.drillableItems, drillableItems = _d === void 0 ? [] : _d, _e = _b.afterRender, afterRender = _e === void 0 ? noop_1["default"] : _e, _f = _b.onCenterPositionChanged, onCenterPositionChanged = _f === void 0 ? noop_1["default"] : _f, _g = _b.onDrill, onDrill = _g === void 0 ? noop_1["default"] : _g, _h = _b.onZoomChanged, onZoomChanged = _h === void 0 ? noop_1["default"] : _h, intl = _b.intl;
        ts_invariant_1["default"](dataView, "invalid state - trying to render geo chart but there is no data to visualize");
        var geoData = geoChartOptions.geoData, colorStrategy = geoChartOptions.colorStrategy, categoryItems = geoChartOptions.categoryItems;
        var segmentIndex = (_a = geoChartOptions.geoData.segment) === null || _a === void 0 ? void 0 : _a.index;
        var drillablePredicates = sdk_ui_1.convertDrillableItemsToPredicates(drillableItems);
        var drillConfig = { dataView: dataView, onDrill: onDrill };
        var chartProps = {
            colorStrategy: colorStrategy,
            config: config,
            dataView: dataView,
            drillableItems: drillablePredicates,
            drillConfig: drillConfig,
            afterRender: afterRender,
            geoData: geoData,
            onCenterPositionChanged: onCenterPositionChanged,
            onZoomChanged: onZoomChanged,
            intl: intl
        };
        if (segmentIndex) {
            var selectedSegmentItems = categoryItems.reduce(function (result, item) {
                if (item.isVisible) {
                    return tslib_1.__spreadArrays(result, [item.uri]);
                }
                return result;
            }, []);
            return tslib_1.__assign(tslib_1.__assign({}, chartProps), { config: tslib_1.__assign(tslib_1.__assign({}, config), { selectedSegmentItems: selectedSegmentItems }) });
        }
        return chartProps;
    };
    GeoChartInner.prototype.updateConfigurationPanel = function (geoChartOptions) {
        ts_invariant_1["default"](geoChartOptions, "illegal state - updating config with no geo options");
        var pushData = this.props.pushData;
        var _a = geoChartOptions, categoryItems = _a.categoryItems, geoData = _a.geoData, colorStrategy = _a.colorStrategy, colorPalette = _a.colorPalette;
        var _b = data_1.getAvailableLegends(categoryItems, geoData), hasCategoryLegend = _b.hasCategoryLegend, hasColorLegend = _b.hasColorLegend, hasSizeLegend = _b.hasSizeLegend;
        var isLegendVisible = hasCategoryLegend || hasColorLegend || hasSizeLegend;
        pushData === null || pushData === void 0 ? void 0 : pushData({
            propertiesMeta: {
                // toggle legend section
                legend_enabled: isLegendVisible
            },
            colors: {
                colorAssignments: colorStrategy.getColorAssignment(),
                colorPalette: colorPalette
            }
        });
    };
    return GeoChartInner;
}(react_1["default"].PureComponent));
exports.GeoChartInner = GeoChartInner;
//# sourceMappingURL=GeoChartInner.js.map